import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

const FILTERLIST_EXPANDER_SELECTOR = "heureka_filterlistExpander";
const FILTERLIST_EXPANDER_EXPANDED_CLASS = `${FILTERLIST_EXPANDER_SELECTOR}--expanded`;

export class FilterlistExpander {
  static readonly factory = HeurekaElementFactory.byClass(FILTERLIST_EXPANDER_SELECTOR, FilterlistExpander);

  constructor(readonly elem: HTMLElement) {}

  /*               */
  static register() {
    eventQBus.on("heureka.filters.loaded", FilterlistExpander.initAll);
  }

  static initAll() {
    FilterlistExpander.factory.forEach((expander) => {
      expander.init();
    });
  }

  private init() {
    this.elem.addEventListener("click", () => {
      FilterlistExpander.factory.forEach((expander) => {
        expander.toggle();
      });
    });
  }

  static prepareAll(fragment: DocumentFragment) {
    FilterlistExpander.factory.forEach((expander) => FilterlistExpander.#prepare(expander), fragment);
  }

  static #prepare(expander: FilterlistExpander) {
    const oldExpander = FilterlistExpander.template();
    if (oldExpander) {
      expander.expanded = oldExpander.expanded;
      if (oldExpander.expanded) {
        expander.elem.setAttribute("expanded", "" + oldExpander.expanded);
      }
    }
  }

  static template(rootElement?: ParentNode | null) {
    return FilterlistExpander.factory.pick(undefined, rootElement);
  }

  get expanded(): boolean {
    return this.elem.classList.contains(FILTERLIST_EXPANDER_EXPANDED_CLASS);
  }

  set expanded(state: boolean) {
    this.elem.classList.toggle(FILTERLIST_EXPANDER_EXPANDED_CLASS, state);
  }

  public toggle(state = !this.expanded) {
    this.expanded = state;
    return state;
  }
}
